<template>
  <piece-card title="接待活动" :icon="flowerIcon" hide-line>
    <div class="reception-body">
      <div class="reception-list">
        <div class="reception-item" v-for="(item, index) in showList" :key="index">
          <div class="reception-title">{{ item.title }}</div>
          <div class="reception-content">
            <div
              class="msg-item"
              :class="[item.type === 1 ? 'horizontal' : 'vertical']"
              v-for="(msg, i) in item.list"
              :key="i"
            >
              <template v-if="msg">
                <template v-if="item.type === 1">
                  <div class="msg-text ellipsis" :title="`${msg.date} ${msg.reason}`">{{ msg.date }} {{ msg.reason }}</div>
                </template>
                <template v-else-if="item.type === 2">
                  <div class="msg-line">
                    <div class="msg-text ellipsis" :title="msg.name">{{ msg.name }}</div>
                    <div class="msg-progress">{{ msg.schedule || 0 }}%</div>
                  </div>
                  <div class="msg-date">{{ msg.start_time }}至{{ msg.end_time }}</div>
                </template>
              </template>
              <div class="empty-text" v-else>暂无数据</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </piece-card>
</template>

<script>
import flowerIcon from "@/assets/classroom/flower.png";
import PieceCard from "../../components/piece-card.vue";

export default {
  name: "ReceptionActivity",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      flowerIcon,
    };
  },
  computed: {
    showList() {
      const { jrjd = [], syhd = [] } = this.info || {};
      const jrjdList = [jrjd[0], jrjd[1]];
      const syhdList = [syhd[0], syhd[1]];
      return [
        { title: "今日接待", type: 1, list: jrjdList },
        { title: "寺院活动", type: 2, list: syhdList },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.reception-body {
  padding-top: 7px;
}
.reception-item {
  &:not(:last-of-type) {
    margin-bottom: 28px;
  }
}
.reception-title {
  color: #fff;
  font-family: "PingFang SC";
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 14px;
}
.reception-content {
  display: flex;
}
.msg-item {
  flex: 1;
  min-width: 0;
  padding: 20px;
  border-left: 2px solid var(--primary-color);
  background-color: rgba(242, 204, 0, 0.15);
  &:not(:last-of-type) {
    margin-right: 14px;
  }
  &.horizontal {
    color: #feffff;
    font-family: "Source Han Sans CN";
    font-size: 16px;
  }
  &.vertical {
    .msg-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #feffff;
      font-family: "Source Han Sans CN";
      font-size: 16px;
      .msg-text {
        flex: 1;
        min-width: 0;
      }
      .msg-progress {
        flex-shrink: 0;
        padding-left: 12px;
      }
    }
    .msg-date {
      color: rgba(254, 255, 255, 0.5);
      font-family: "Source Han Sans CN";
      font-size: 14px;
      padding-top: 17px;
    }
  }
}
.empty-text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f9e6b3;
}
</style>
